import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress UNSAFE_componentWillMount warning from react-helmet in StrictMode
// This is a third-party library warning and doesn't affect functionality
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('UNSAFE_componentWillMount')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

// 🔴 CRITICAL: Service Worker Cleanup in Development
if (process.env.NODE_ENV === 'development') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      if (registrations.length > 0) {
        registrations.forEach(reg => {
          reg.unregister().then(() => {
            console.log('🧹 Service Worker unregistered in development');
          }).catch(err => {
            console.error('Failed to unregister Service Worker:', err);
          });
        });
      }
    });
  }

  // 🔴 Suppress noisy WebSocket warnings in development
  console.log('🔧 Development Mode Enabled - Service Workers and auto-reconnection disabled');
}

// React root initialization
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
